import { environment } from '../../../environments/environment.local';
import { DevTenantSwitcherService } from '../config/dev-tenant-switcher.service';
import { AppMode } from './app-mode';
import { detectMode } from './mode-detector';
import { ModeService } from './mode.service';

export function initializeMode(
  modeService: ModeService,
  devSwitcher: DevTenantSwitcherService,
): () => void {
  return () => {
    let mode: AppMode = detectMode(window.location.host, environment.rootDomain, {
      subdomainPrefix: environment.subdomainPrefix,
      extraPlatformHosts: environment.extraPlatformHosts,
    });

    if (!environment.production) {
      const override = devSwitcher.getOverride();
      if (override !== null && override.length > 0) {
        mode = { kind: 'tenant', subdomain: override };
      }
    }

    modeService.setMode(mode);
  };
}
